export default {"src":"/gallery/_next/static/media/crypto.9a38178b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};